<template>
    <z-basePage :title="title" :pop="true">
        <z-backForm :name="'back-taskType'" :align="true" @save="saveSet" @cancel="backset">
            <!-- 类型名称 -->
            <div class="back-item">
                <div class="back-title">类型名称</div>
                <div class="back-wrap">
                    <el-input class="top-choose" rule="limit" v-arg="[2,15]" v-tar="sub.name" v-model="sub.name" placeholder="请填写名称"></el-input>
                    <!-- <el-select class="top-choose" rule="noVal" v-tar="sub.name" v-model="sub.name" placeholder="请填写名称">
						<el-option v-for="item in typeArr" :key="item.type" :value="item.type" :label="item.label">
						</el-option>
					</el-select> -->
                    <div class="tip">请输入2-15个字符,且不允许出现空格</div>
                </div>
            </div>
            <!-- 类型说明 -->
            <div class="back-item area">
                <div class="back-title">类型说明</div>
                <div class="back-wrap">
                    <textarea rule="reason describe_limit" v-arg="'类型说明'" v-tar="sub.describe" v-model="sub.describe" placeholder="请输入任务类型说明"></textarea>
                </div>
            </div>
            <!-- 周期范围  -->
            <div class="back-item">
                <div class="back-title">周期范围</div>
                <div class="back-wrap back-range" v-group>
                    <el-input class="top-choose small" rule="scope number" v-tar="sub.min_date" v-model="sub.min_date">
                        <template slot="append">天</template>
                    </el-input>
                    <span>~</span>
                    <el-input class="top-choose small" rule="scope number" v-tar="sub.max_date" v-model="sub.max_date">
                        <template slot="append">天</template>
                    </el-input>
                </div>
            </div>
            <!-- 快币选择  -->
            <!-- <div class="back-item" :style="{height:change_height}">
                <div class="back-title">快币选择</div>
                <div class="back-wrap check" ref="check">
                    <el-checkbox-group  v-model="sub.currency_ids">
                        <el-checkbox v-for="item in currency_list" :label="item.id+''" :key="item.id">{{ item.currency_name }}</el-checkbox>
                    </el-checkbox-group>
                    <input ref="checkInput" v-show="false" rule="checkgroup" v-tar="currency_str">
                </div>
            </div> -->
            <!-- 快币数量 -->
            <div class="back-item">
                <div class="back-title">任务金额</div>
                <div class="back-wrap back-range" v-group>
                    <el-input class="top-choose small" rule="scope number" v-tar="sub.min_bonus" v-model="sub.min_bonus">
                        <template slot="append">{{ task_curr.currency_name }}</template>
                    </el-input>
                    <span>~</span>
                    <el-input class="top-choose small" rule="scope number" v-tar="sub.max_bonus" v-model="sub.max_bonus">
                        <template slot="append">{{ task_curr.currency_name }}</template>
                    </el-input>
                </div>
            </div>
            <!-- 上传文档 -->
            <div class="back-item">
                <div class="back-title" :class="{add:sub.file_flag}">上传文档</div>
                <div class="back-wrap check">
                    <el-switch v-model="sub.file_flag"  @change="hideError('file')" on-text="" off-text="">
                    </el-switch>
                    <div v-tar="sub.file_flag">是否需要上传文档</div>

                    <transition name="fade">
                        <div class="file-wrap" v-show="sub.file_flag" @click="hideError('file')">
                            <z-scrollDiv class="file-list" ref="file" v-tar="file_str" :rule="file_rule" v-arg="'上传文档'">
                                <div class="file-item" v-for="(item,index) in files" :key="item.id">
                                    <span>{{ item.tpl_doc_name }}</span>
                                    <span @click="removeFlie(item,index)">移除</span>
                                </div>
                                <div class="file-item" v-for="(item,index) in sub.fileList" :key="item.name">
                                    <span>{{ item.name }}</span>
                                    <span @click="sub.fileList.splice(index,1)">移除</span>
                                </div>
                            </z-scrollDiv>
                            <div class="back-btn " @click="hideError('file')">添加
                                 <input type="file" multiple @change="addUpItem($event)">
                            </div>
                        </div>
                    </transition>
                </div>
            </div>



        </z-backForm>

    </z-basePage>
</template>

<script>
    import { mapState,mapGetters } from "vuex";

    export default {
        data(){
            return {
                change_height:"auto",  //调整高度
                files:[],  // 已上传的文档
                delete_ids:[], //删除文档的id
                sub:{
                    name:"",
                    describe:"",
                    min_date:"",
                    max_date:"",
                    // currency_ids:[],
                    min_bonus:"",
                    max_bonus:"",
                    file_flag:false,
                    fileList:[],
                },
            }
        },
        computed:{
            ...mapGetters(['task_curr']),
            // ...mapState(["currencyList"]),
            // currency_list(){  //任务快币列表
            //     return this.currencyList.filter(item=>item.currency_type == 10);
            // },
            Id(){   //任务类型id
                return this.$crypto.decrypt(this.$route.params.id);
            },
            title(){
                return this.Id == 0?'新建任务类型':"编辑任务类型";
            },
            file_rule(){
                if(this.sub.file_flag){
                    return (this.files.length == 0 && this.sub.fileList.length == 0)?"noVal":"";
                }
                return "";
            },
            file_str(){  //字符化
                return this.sub.fileList.reduce((str,file)=>{
                    return str + file.toString();
                },"");
            },
            // currency_str(){
            //     return this.sub.currency_ids && this.sub.currency_ids.join(',');
            // }

        },
        // watch:{
        //     "sub.currency_ids"(){
        //         this.hideError('checkInput');
        //     }
        // },

        created(){
            // this.$func.getCurrencyList(true,list=>{
            //     setTimeout(()=>{
            //         this.change_height = this.$refs['check'].offsetHeight+"px";
            //     });
            // });

            if(this.Id != 0){
                this.getData();
            }
        },

        beforeRouteLeave(to,from,next){  //离开页面之前
			let res = this.$form.leave({name:'back-taskType',path:to.path});
			next(res);
        },
        

        methods:{
            getData(){
                let url = `api/admin/task_tpl_detail/${this.Id}`;
                this.$http.get(url).then(res=>{
                    if(res.status == 200){
                        let data = res.res_data;

                        this.sub.name = data.tplName ;
                        this.sub.describe = data.tplDescription ;
                        this.sub.min_date = data.tplTaskRange.split(",")[0];
                        this.sub.max_date = data.tplTaskRange.split(",")[1];
                        // this.sub.currency_ids = data.tplCurrencyIds.split(",");
                        this.sub.min_bonus = data.tplCurrencyRange.split(",")[0] ;
                        this.sub.max_bonus = data.tplCurrencyRange.split(",")[1] ;
                        this.sub.file_flag = data.tplDocRequire == 1?true:false;
                        this.sub.fileList = [];
                        this.delete_ids = [];
                        this.files = data.docs || [];

                        this.$form.init('back-taskType');
                        console.log(this.$form.forms['back-taskType'])
                    }
                }).catch(err=>{ 
                    this.errorTip("出错了");
                });
            },
            // ***按钮
            saveSet(){
                this.$func.loading(true);

                let formData = new FormData();
                if(this.Id!=0){
                    formData.append("id",this.Id);
                }
                formData.append("tpl_name",this.sub.name);
                formData.append("tpl_description",this.sub.describe);
                formData.append("tpl_task_range",[this.sub.min_date,this.sub.max_date]);
                // formData.append("tpl_currency_ids",this.sub.currency_ids);
                formData.append("tpl_currency_range",[this.sub.min_bonus,this.sub.max_bonus]);
                formData.append("tpl_doc_require",this.sub.file_flag?1:0);

                if(this.sub.file_flag){
                    for(let i=0,len=this.sub.fileList.length;i<len;i++){
                        formData.append("uploadFiles",this.sub.fileList[i]);
                    }
                }
                if(this.delete_ids.length > 0){
                    formData.append("deleteFilesIds",this.delete_ids);
                }
        
                let url = `api/admin/task_tpl`;
                this.$http.post(url,formData,{
                    transformRequest: [function (data) {
                        return data;
                    }]
                }).then(res=>{
                    if(res.status == 200){
                        if(this.Id!=0){
                            this.getData();
                            this.successTip("保存成功");
                        }else{
                            let str = this.$crypto.encrypt(res.res_data.id);
                            this.$router.replace({
                                name:'back-setting-addTaskType',
                                params:{
                                    id:str,
                                }
                            });
                            this.getData();
                            this.successTip("创建成功");
                        }
                    }
                    this.$func.loading(false);
                }).catch(err=>{
                    this.errorTip("出错了");
                    this.$func.loading(false);
                });

            },
            backset(dataArr){  
                if(this.Id != 0){
                    this.getData();
                }else{
                    let sub = this.sub;
                    sub.name = "";
                    sub.describe = "";
                    sub.min_date = "";
                    sub.max_date = "";
                    // sub.currency_ids = [];
                    sub.min_bonus = "";
                    sub.max_bonus = "";
                    sub.file_flag = false;
                    sub.fileList = [];
                    this.delete_ids = [];
                    this.files = [];
                }
            },

            hideError(ref_name){  //隐藏错误信息
                this.$form.hideError(this.$refs[ref_name]); 
            },
            addUpItem(event){  //上传文档
                let input = event.target;
                let list = this.sub.fileList;

                for (let item of input.files) {
                    list.push(item);
                }
                input.value = "";
            },
            removeFlie(item,index){  //删除文档
                this.delete_ids.push(item.id);
                this.files.splice(index,1);
            },

        },
    }
</script>

<style lang="less" scoped>
    @import "~src/assets/less/var.less";
    @width:300px;
    .file-wrap{
        height:120px;
        width:@width;
        margin-top: 15px;
        transition:0.3s;
        position: relative;
        .file-list{
            height: 100%;
            box-sizing: border-box;
            border: 1px solid #333;
            width:@width;
            float: left;
            box-sizing: border-box;
            .file-item{
                position: relative;
                overflow: hidden;
                transition: 0.3s;
                line-height: 25px;
                box-sizing: border-box;
                padding:0 10px;
                font-size: 12px;
                &:hover{
                    background:#e2edfa;
                }
                >span:first-child{
                    display:block;
                    width:230px;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    
                }
                >span:last-child{  //删除
                    position:absolute;
                    top:50%;
                    right:20px;
                    transform: translateY(-50%);
                    display:inline-block;
                    color:@red;
                    cursor: pointer;
                }
            }
        }
        .red{
            border-color: @red;
        }
        .back-btn{
            // margin-top: 120px - 30px;
            // margin-left:15px;
            position: absolute;
            bottom: 0;
            left:calc(~"100% + 15px");
            input{
                position: absolute;
                width:100%;
                height: 100%;
                opacity: 0;
                left: 0;
                top:0;
                cursor: pointer;
            }
        }
    }
    .add{
        height:calc(~"30px + 120px + 15px");
    }

    .check{
        margin-bottom: 26px;
    }

</style>





// WEBPACK FOOTER //
// page-taskType-add.vue?4abbd1f8